import { ArticleSortFields, SortOrder } from "@/shared/services/graphql/generated/consumer-graph-types";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

export function useArticlesListSort() {
    const { t } = useI18n();

    const sortOrderItems = computed(() => {
        return [
            {
                id: "Ranking",
                title: t("shared.Ranking"),
                value: {
                    field: ArticleSortFields.score,
                    order: SortOrder.desc,
                },
            },
            {
                id: "Articlenumber ascending",
                title: t("mechanic.Article number ascending"),
                value: {
                    field: ArticleSortFields.articleNumber,
                    order: SortOrder.asc,
                },
            },
            {
                id: "Articlenumber descending",
                title: t("mechanic.Article number descending"),
                value: {
                    field: ArticleSortFields.articleNumber,
                    order: SortOrder.desc,
                },
            },
            {
                id: "Title ascending",
                title: t("mechanic.Title ascending"),
                value: {
                    field: ArticleSortFields.title,
                    order: SortOrder.asc,
                },
            },
            {
                id: "Title descending",
                title: t("shared.Title descending"),
                value: {
                    field: ArticleSortFields.title,
                    order: SortOrder.desc,
                },
            },
        ];
    });

    return { sortOrderItems };
}
